"use strict"

import React from "react"

import { withZoomState } from "../../../config/ZoomConfigProvider"
import { isLTPM } from "../../../../components/shared_components_registration"

const registration = {
  no_data_msg: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.no.data" }) : "No data in selected time range.",
  show_full_range_msg: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.show.full.time.range" }) : "Show full time range?",
}

function NoGraphingDataMessage({ intl, zoomConfig }) {
  return (
    <div
      style={{
        width: "80%",
        background: isLTPM ? "var(--lanzalake-white)" : "var(--lanzalake-grey-light-1)",
        margin: "10px auto",
        textAlign: "center",
        padding: "4px",
      }}
    >
      {registration.no_data_msg(intl)}
      <a
        href={"#"}
        onClick={() => {
          zoomConfig.unzoomTime()
        }}
      >
        &nbsp; [{registration.show_full_range_msg(intl)}]
      </a>
    </div>
  )
}

export default withZoomState(NoGraphingDataMessage)
